import { ChangePasswordError } from "../errors";
import { handleXcoreError } from "../errors/handleError";
import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";

/**
 * @throws {ChangePasswordError}
 */
export const changePassword = (oldPassword: string, newPassword: string, core: XcoreCore): BaseApiRequest<void> =>
  core
    .fetch("/api/user/change-password", {
      method: "POST",
      body: JSON.stringify({ oldPassword, newPassword }),
    })
    .then((res, url) => (res.ok ? undefined : handleChangePasswordError(url, res)));

const handleChangePasswordError = handleXcoreError((...args) => new ChangePasswordError(...args));
